import React, { useState } from 'react';
import { Layout } from 'antd';
import HeaderContent from '../HeaderContent';
import Sidebar from '../SideBar';
import { useHistory } from 'react-router-dom';

const { Header, Content } = Layout;

const MainLayout = (props: any) => {
  const [checkbox, setCheckbox] = useState([false, true]);
  const history = useHistory();

  return (
    <Layout className="root-layout-sider">
      <Sidebar setCheckbox={setCheckbox} checkbox={checkbox} collapsed={true} />
      <Layout>
        <Header className="site-layout-background-header" style={{ padding: 0 }}>
          <HeaderContent setCheckbox={setCheckbox} checkbox={checkbox} />
        </Header>
        <Content
          className={`${history.location.pathname === '/' ? 'site-layout' : "site-layout-background"}`}
        >
          {props.children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
